var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "view-content container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c("heading", {
                  attrs: {
                    upper: "Feature title (source_title)",
                    lower: _vm.session.source_title,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Movix ID",
                    lower: _vm.session.movix_id,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Feature DCP",
                    lower: _vm.session.feature_dcp,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Feature UUID",
                    lower: _vm.session.feature_uuid,
                    border: "",
                    size: "sm",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c("heading", {
                  attrs: {
                    upper: "Theatre",
                    lower: `${_vm.theatre.name} (${_vm.theatre.code})`,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Screen number & capacity",
                    lower: `${_vm.session.screen_number} (${
                      _vm.session.screen_capacity || "0"
                    })`,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Screen type",
                    lower: _vm.session.screen_type.join(),
                    border: "",
                    size: "sm",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c("heading", {
                  attrs: {
                    upper: "Showtimes Session ID",
                    lower: _vm.session.id,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Exhibitor Session ID",
                    lower: _vm.session.session_exhibitor_id,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Session day",
                    lower: _vm.session.session_day,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Session time",
                    lower: `${_vm.session.session_time} (${_vm.session.session_time_zone})`,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Session week",
                    lower: `${_vm.lineup.week_code} (${_vm.lineup.first_day}—${_vm.lineup.last_day})`,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Session time type",
                    lower: _vm.session.session_time_type,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Session language (parsed, original)",
                    lower: `${_vm.session.session_lang} (${_vm.session.session_lang_original})`,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Session type",
                    lower: _vm.session.session_type,
                    border: "",
                    size: "sm",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c("heading", {
                  attrs: {
                    upper: "Aspect ratio",
                    lower: _vm.session.content_aspect,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Dimension",
                    lower: _vm.session.content_dimension,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Immersive",
                    lower: _vm.session.content_immersive,
                    border: "",
                    size: "sm",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c("heading", {
                  attrs: {
                    upper: "Source",
                    lower: _vm.lineup.source,
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Created at",
                    lower: _vm
                      .$dayjs(_vm.session.created_at)
                      .format("DD MMM YYYY HH:mm:ss"),
                    border: "",
                    size: "sm",
                  },
                }),
                _vm._v(" "),
                _c("heading", {
                  attrs: {
                    upper: "Updated at",
                    lower: _vm.session.updated_at,
                    border: "",
                    size: "sm",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c(
            "ol",
            { staticClass: "list-unstyled" },
            _vm._l(_vm.playlists, function (playlist, p) {
              return _c(
                "li",
                { key: p },
                [
                  _c("div", { staticClass: "box" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "box-content d-flex justify-content-between align-items-center",
                        on: { click: () => _vm.togglePlaylistVisibility(p) },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("playlist-badge", {
                              attrs: {
                                status: playlist.playlist_provider_version,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              { staticClass: "btn btn-sm btn-link" },
                              [
                                _c("icon", {
                                  attrs: {
                                    name:
                                      "chevron-" +
                                      (_vm.visible[p] ? "up" : "down"),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(playlist.playlist_provider_id) +
                                "\n                                     \n                                    "
                            ),
                            _c("playlist-badge", {
                              attrs: { status: playlist.status },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      attrs: { accordion: "my-accordion", role: "tabpanel" },
                      model: {
                        value: _vm.visible[p],
                        callback: function ($$v) {
                          _vm.$set(_vm.visible, p, $$v)
                        },
                        expression: "visible[p]",
                      },
                    },
                    [
                      _c("div", { staticClass: "box" }, [
                        _c(
                          "div",
                          { staticClass: "box-content" },
                          [
                            _c("heading", {
                              attrs: {
                                upper: "Feature title",
                                lower: playlist.raw.feature.title,
                                border: "",
                                size: "sm",
                              },
                            }),
                            _vm._v(" "),
                            _c("heading", {
                              attrs: {
                                upper: "Movix ID",
                                lower: playlist.movix_id,
                                border: "",
                                size: "sm",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box" }, [
                        _c(
                          "div",
                          { staticClass: "box-content" },
                          [
                            _c("heading", {
                              attrs: {
                                upper: "Theatre",
                                lower: playlist.theatre_code,
                                border: "",
                                size: "sm",
                              },
                            }),
                            _vm._v(" "),
                            _c("heading", {
                              attrs: {
                                upper: "Screen(s)",
                                lower: playlist.screens.join(),
                                border: "",
                                size: "sm",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box" }, [
                        _c(
                          "div",
                          { staticClass: "box-content" },
                          [
                            _c("heading", {
                              attrs: {
                                upper: "Week",
                                lower: playlist.week_code,
                                border: "",
                                size: "sm",
                              },
                            }),
                            _vm._v(" "),
                            _c("heading", {
                              attrs: {
                                upper: "Validity period",
                                lower: `${playlist.valid_from} — ${playlist.valid_to}`,
                                border: "",
                                size: "sm",
                              },
                            }),
                            _vm._v(" "),
                            _c("heading", {
                              attrs: {
                                upper: "Timezone",
                                lower: playlist.time_zone,
                                border: "",
                                size: "sm",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box" }, [
                        _c(
                          "div",
                          { staticClass: "box-content" },
                          [
                            _c("heading", {
                              attrs: {
                                upper: "Created at",
                                lower: playlist.created_at,
                                border: "",
                                size: "sm",
                              },
                            }),
                            _vm._v(" "),
                            _c("heading", {
                              attrs: {
                                upper: "Updated at",
                                lower: playlist.updated_at,
                                border: "",
                                size: "sm",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "view-nav" }, [
      _c("div", { staticClass: "container-fluid p-0" }, [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col-6" }, [_vm._v("Imported Session")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6" }, [_vm._v("Imported Playlist(s)")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }